import axios from '@ts/utils/axios';

export const pay = (payload = {}) => axios.post('/checkout/pay', payload).then(({ data }) => data);
export const config = () => axios.get('/config').then(({ data }) => data);
export const token = () => axios.get('/checkout/token').then(({ data }) => data);
export const saveUser = (payload = {}) =>
    axios.post('/checkout/save-user', payload).then(({ data }) => data);
